// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-detail {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
  background: var(--vb-bg);
  color: var(--vb-text);
}

.team-detail-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e9ecef;
}

.team-detail.night-mode .team-detail-header {
  border-bottom-color: #495057;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--vb-surface);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-size: 14px;
  font-weight: 650;
}

.back-btn:hover {
  background: #5a6268;
}

.team-detail.night-mode .back-btn {
  background: #495057;
}

.team-detail.night-mode .back-btn:hover {
  background: #6c757d;
}

.team-title h1 {
  margin: 0;
  font-size: 2.5rem;
  font-weight: bold;
}

.team-subtitle {
  color: #6c757d;
  font-size: 1rem;
  display: block;
  margin-top: 5px;
}

.team-detail.night-mode .team-subtitle {
  color: #adb5bd;
}

.team-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
  border-bottom: 2px solid #e9ecef;
}

.team-detail.night-mode .team-tabs {
  border-bottom-color: #495057;
}

.tab-btn {
  padding: 12px 20px;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #6c757d;
  transition: all 0.2s;
}

.tab-btn:hover {
  color: #007bff;
}

.tab-btn.active {
  color: #007bff;
  border-bottom-color: #007bff;
}

.team-detail.night-mode .tab-btn {
  color: #adb5bd;
}

.team-detail.night-mode .tab-btn:hover,
.team-detail.night-mode .tab-btn.active {
  color: #007bff;
}

.stats-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border: 1px solid #e9ecef;
}

.team-detail.night-mode .stat-card {
  background: #343a40;
  border-color: #495057;
  color: white;
}

.stat-icon {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  color: #6c757d;
}

.stat-icon.win {
  background: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.team-detail.night-mode .stat-icon {
  background: #495057;
  color: #adb5bd;
}

.team-detail.night-mode .stat-icon.win {
  background: rgba(40, 167, 69, 0.2);
  color: #28a745;
}

.stat-content h3 {
  margin: 0;
  font-size: 2rem;
  font-weight: bold;
  color: #2c3e50;
}

.stat-content p {
  margin: 5px 0 0 0;
  color: #6c757d;
  font-size: 0.9rem;
}

.team-detail.night-mode .stat-content h3 {
  color: white;
}

.team-detail.night-mode .stat-content p {
  color: #adb5bd;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 30px;
}

.chart-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border: 1px solid #e9ecef;
}

.team-detail.night-mode .chart-container {
  background: #343a40;
  border-color: #495057;
  color: white;
}

.chart-container h3 {
  margin: 0 0 20px 0;
  color: #2c3e50;
  font-size: 1.2rem;
}

.team-detail.night-mode .chart-container h3 {
  color: white;
}

.recent-form-container {
  grid-column: 1 / -1;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border: 1px solid #e9ecef;
}

.team-detail.night-mode .recent-form-container {
  background: #343a40;
  border-color: #495057;
  color: white;
}

.form-display {
  display: flex;
  gap: 8px;
  margin: 15px 0;
  flex-wrap: wrap;
}

.form-indicator {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
}

.form-indicator.form-win {
  background: #28a745;
}

.form-indicator.form-loss {
  background: #dc3545;
}

.form-indicator.form-tie {
  background: #ffc107;
  color: #212529;
}

.form-legend {
  margin: 10px 0 0 0;
  font-size: 0.9rem;
  color: #6c757d;
}

.team-detail.night-mode .form-legend {
  color: #adb5bd;
}

.form-legend .form-win,
.form-legend .form-loss,
.form-legend .form-tie {
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: bold;
  margin: 0 5px;
}

.detailed-stats {
  grid-column: 1 / -1;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border: 1px solid #e9ecef;
}

.team-detail.night-mode .detailed-stats {
  background: #343a40;
  border-color: #495057;
  color: white;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.team-detail.night-mode .stat-item {
  background: #495057;
  border-color: #6c757d;
}

.stat-label {
  color: #6c757d;
  font-size: 0.9rem;
}

.stat-value {
  font-weight: bold;
  color: #2c3e50;
  font-size: 1rem;
}

.team-detail.night-mode .stat-label {
  color: #adb5bd;
}

.team-detail.night-mode .stat-value {
  color: white;
}

.matches-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.match-item {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border: 1px solid #e9ecef;
  border-left: 4px solid #6c757d;
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  gap: 15px;
  align-items: center;
}

.match-item.win {
  border-left-color: #28a745;
}

.match-item.loss {
  border-left-color: #dc3545;
}

.match-item.tie {
  border-left-color: #ffc107;
}

.team-detail.night-mode .match-item {
  background: #343a40;
  border-color: #495057;
  color: white;
}

.match-date {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6c757d;
  font-size: 0.9rem;
  min-width: 120px;
}

.team-detail.night-mode .match-date {
  color: #adb5bd;
}

.match-teams {
  display: flex;
  align-items: center;
  gap: 10px;
}

.team-name {
  font-weight: bold;
  color: #2c3e50;
}

.vs {
  color: #6c757d;
  font-size: 0.9rem;
}

.opponent-name {
  color: #007bff;
  cursor: pointer;
}

.opponent-name:hover {
  text-decoration: underline;
}

.team-detail.night-mode .team-name {
  color: white;
}

.team-detail.night-mode .vs {
  color: #adb5bd;
}

.match-score {
  font-weight: bold;
  font-size: 1.1rem;
  min-width: 80px;
  text-align: center;
}

.score.win {
  color: #28a745;
}

.score.loss {
  color: #dc3545;
}

.score.tie {
  color: #ffc107;
}

.match-time {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #6c757d;
  font-size: 0.9rem;
  min-width: 80px;
}

.team-detail.night-mode .match-time {
  color: #adb5bd;
}

.match-group {
  grid-column: 2;
  font-size: 0.8rem;
  color: #007bff;
  background: rgba(0, 123, 255, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
  width: fit-content;
}

.match-note {
  grid-column: 2;
  font-size: 0.9rem;
  color: #6c757d;
  font-style: italic;
}

.team-detail.night-mode .match-note {
  color: #adb5bd;
}

.players-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.player-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
  transition: all 0.2s;
}

.player-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.team-detail.night-mode .player-card {
  background: #343a40;
  border-color: #495057;
  color: white;
}

.player-icon {
  background: #f8f9fa;
  border-radius: 50%;
  padding: 12px;
  color: #6c757d;
}

.team-detail.night-mode .player-icon {
  background: #495057;
  color: #adb5bd;
}

.player-info {
  flex: 1 1;
}

.player-info h4 {
  margin: 0 0 5px 0;
  color: #2c3e50;
  font-size: 1.1rem;
}

.team-detail.night-mode .player-info h4 {
  color: white;
}

.player-number {
  background: #007bff;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: bold;
  margin-right: 10px;
}

.player-position {
  color: #6c757d;
  font-size: 0.9rem;
}

.team-detail.night-mode .player-position {
  color: #adb5bd;
}

.player-status .status {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
}

.status.active {
  background: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.status.inactive {
  background: rgba(108, 117, 125, 0.1);
  color: #6c757d;
}

.opponents-table {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border: 1px solid #e9ecef;
  overflow-x: auto;
}

.team-detail.night-mode .opponents-table {
  background: #343a40;
  border-color: #495057;
}

.opponents-table table {
  width: 100%;
  border-collapse: collapse;
}

.opponents-table th,
.opponents-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}

.team-detail.night-mode .opponents-table th,
.team-detail.night-mode .opponents-table td {
  border-bottom-color: #495057;
  color: white;
}

.opponents-table th {
  background: #f8f9fa;
  font-weight: bold;
  color: #2c3e50;
}

.team-detail.night-mode .opponents-table th {
  background: #495057;
  color: white;
}

.opponent-name {
  font-weight: bold;
  color: #007bff;
  cursor: pointer;
}

.opponent-name:hover {
  text-decoration: underline;
}

.opponents-table .wins {
  color: #28a745;
  font-weight: bold;
}

.opponents-table .losses {
  color: #dc3545;
  font-weight: bold;
}

.opponents-table .ties {
  color: #ffc107;
  font-weight: bold;
}

.win-percentage {
  font-weight: bold;
}

.loading,
.error-message,
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;
}

.team-detail.night-mode .loading,
.team-detail.night-mode .error-message,
.team-detail.night-mode .empty-state {
  color: #adb5bd;
}

.retry-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 15px;
  transition: background-color 0.2s;
}

.retry-btn:hover {
  background: #0056b3;
}

@media (max-width: 768px) {
  .team-detail {
    padding: 15px;
  }
  
  .team-detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .team-title h1 {
    font-size: 2rem;
  }
  
  .stats-summary {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 15px;
  }
  
  .charts-grid {
    grid-template-columns: 1fr;
  }
  
  .tab-btn {
    padding: 10px 15px;
    font-size: 14px;
  }
  
  .match-item {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .match-group,
  .match-note {
    grid-column: 1;
  }
  
  .players-grid {
    grid-template-columns: 1fr;
  }
  
  .opponents-table {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TeamDetail.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".team-detail {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  min-height: 100vh;\n  background: var(--vb-bg);\n  color: var(--vb-text);\n}\n\n.team-detail-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.team-detail.night-mode .team-detail-header {\n  border-bottom-color: #495057;\n}\n\n.back-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.back-btn:hover {\n  background: #5a6268;\n}\n\n.team-detail.night-mode .back-btn {\n  background: #495057;\n}\n\n.team-detail.night-mode .back-btn:hover {\n  background: #6c757d;\n}\n\n.team-title h1 {\n  margin: 0;\n  font-size: 2.5rem;\n  font-weight: bold;\n}\n\n.team-subtitle {\n  color: #6c757d;\n  font-size: 1rem;\n  display: block;\n  margin-top: 5px;\n}\n\n.team-detail.night-mode .team-subtitle {\n  color: #adb5bd;\n}\n\n.team-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 30px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.team-detail.night-mode .team-tabs {\n  border-bottom-color: #495057;\n}\n\n.tab-btn {\n  padding: 12px 20px;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  color: #6c757d;\n  transition: all 0.2s;\n}\n\n.tab-btn:hover {\n  color: #007bff;\n}\n\n.tab-btn.active {\n  color: #007bff;\n  border-bottom-color: #007bff;\n}\n\n.team-detail.night-mode .tab-btn {\n  color: #adb5bd;\n}\n\n.team-detail.night-mode .tab-btn:hover,\n.team-detail.night-mode .tab-btn.active {\n  color: #007bff;\n}\n\n.stats-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.stat-card {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  border: 1px solid #e9ecef;\n}\n\n.team-detail.night-mode .stat-card {\n  background: #343a40;\n  border-color: #495057;\n  color: white;\n}\n\n.stat-icon {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 12px;\n  color: #6c757d;\n}\n\n.stat-icon.win {\n  background: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.team-detail.night-mode .stat-icon {\n  background: #495057;\n  color: #adb5bd;\n}\n\n.team-detail.night-mode .stat-icon.win {\n  background: rgba(40, 167, 69, 0.2);\n  color: #28a745;\n}\n\n.stat-content h3 {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: bold;\n  color: #2c3e50;\n}\n\n.stat-content p {\n  margin: 5px 0 0 0;\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n.team-detail.night-mode .stat-content h3 {\n  color: white;\n}\n\n.team-detail.night-mode .stat-content p {\n  color: #adb5bd;\n}\n\n.charts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 30px;\n}\n\n.chart-container {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  border: 1px solid #e9ecef;\n}\n\n.team-detail.night-mode .chart-container {\n  background: #343a40;\n  border-color: #495057;\n  color: white;\n}\n\n.chart-container h3 {\n  margin: 0 0 20px 0;\n  color: #2c3e50;\n  font-size: 1.2rem;\n}\n\n.team-detail.night-mode .chart-container h3 {\n  color: white;\n}\n\n.recent-form-container {\n  grid-column: 1 / -1;\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  border: 1px solid #e9ecef;\n}\n\n.team-detail.night-mode .recent-form-container {\n  background: #343a40;\n  border-color: #495057;\n  color: white;\n}\n\n.form-display {\n  display: flex;\n  gap: 8px;\n  margin: 15px 0;\n  flex-wrap: wrap;\n}\n\n.form-indicator {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  color: white;\n  font-size: 14px;\n}\n\n.form-indicator.form-win {\n  background: #28a745;\n}\n\n.form-indicator.form-loss {\n  background: #dc3545;\n}\n\n.form-indicator.form-tie {\n  background: #ffc107;\n  color: #212529;\n}\n\n.form-legend {\n  margin: 10px 0 0 0;\n  font-size: 0.9rem;\n  color: #6c757d;\n}\n\n.team-detail.night-mode .form-legend {\n  color: #adb5bd;\n}\n\n.form-legend .form-win,\n.form-legend .form-loss,\n.form-legend .form-tie {\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: bold;\n  margin: 0 5px;\n}\n\n.detailed-stats {\n  grid-column: 1 / -1;\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  border: 1px solid #e9ecef;\n}\n\n.team-detail.night-mode .detailed-stats {\n  background: #343a40;\n  border-color: #495057;\n  color: white;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.stat-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.team-detail.night-mode .stat-item {\n  background: #495057;\n  border-color: #6c757d;\n}\n\n.stat-label {\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n.stat-value {\n  font-weight: bold;\n  color: #2c3e50;\n  font-size: 1rem;\n}\n\n.team-detail.night-mode .stat-label {\n  color: #adb5bd;\n}\n\n.team-detail.night-mode .stat-value {\n  color: white;\n}\n\n.matches-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.match-item {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  border: 1px solid #e9ecef;\n  border-left: 4px solid #6c757d;\n  display: grid;\n  grid-template-columns: auto 1fr auto auto;\n  gap: 15px;\n  align-items: center;\n}\n\n.match-item.win {\n  border-left-color: #28a745;\n}\n\n.match-item.loss {\n  border-left-color: #dc3545;\n}\n\n.match-item.tie {\n  border-left-color: #ffc107;\n}\n\n.team-detail.night-mode .match-item {\n  background: #343a40;\n  border-color: #495057;\n  color: white;\n}\n\n.match-date {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #6c757d;\n  font-size: 0.9rem;\n  min-width: 120px;\n}\n\n.team-detail.night-mode .match-date {\n  color: #adb5bd;\n}\n\n.match-teams {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.team-name {\n  font-weight: bold;\n  color: #2c3e50;\n}\n\n.vs {\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n.opponent-name {\n  color: #007bff;\n  cursor: pointer;\n}\n\n.opponent-name:hover {\n  text-decoration: underline;\n}\n\n.team-detail.night-mode .team-name {\n  color: white;\n}\n\n.team-detail.night-mode .vs {\n  color: #adb5bd;\n}\n\n.match-score {\n  font-weight: bold;\n  font-size: 1.1rem;\n  min-width: 80px;\n  text-align: center;\n}\n\n.score.win {\n  color: #28a745;\n}\n\n.score.loss {\n  color: #dc3545;\n}\n\n.score.tie {\n  color: #ffc107;\n}\n\n.match-time {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: #6c757d;\n  font-size: 0.9rem;\n  min-width: 80px;\n}\n\n.team-detail.night-mode .match-time {\n  color: #adb5bd;\n}\n\n.match-group {\n  grid-column: 2;\n  font-size: 0.8rem;\n  color: #007bff;\n  background: rgba(0, 123, 255, 0.1);\n  padding: 2px 8px;\n  border-radius: 4px;\n  width: fit-content;\n}\n\n.match-note {\n  grid-column: 2;\n  font-size: 0.9rem;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.team-detail.night-mode .match-note {\n  color: #adb5bd;\n}\n\n.players-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.player-card {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  border: 1px solid #e9ecef;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.player-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.team-detail.night-mode .player-card {\n  background: #343a40;\n  border-color: #495057;\n  color: white;\n}\n\n.player-icon {\n  background: #f8f9fa;\n  border-radius: 50%;\n  padding: 12px;\n  color: #6c757d;\n}\n\n.team-detail.night-mode .player-icon {\n  background: #495057;\n  color: #adb5bd;\n}\n\n.player-info {\n  flex: 1;\n}\n\n.player-info h4 {\n  margin: 0 0 5px 0;\n  color: #2c3e50;\n  font-size: 1.1rem;\n}\n\n.team-detail.night-mode .player-info h4 {\n  color: white;\n}\n\n.player-number {\n  background: #007bff;\n  color: white;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: bold;\n  margin-right: 10px;\n}\n\n.player-position {\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n.team-detail.night-mode .player-position {\n  color: #adb5bd;\n}\n\n.player-status .status {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: bold;\n}\n\n.status.active {\n  background: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.status.inactive {\n  background: rgba(108, 117, 125, 0.1);\n  color: #6c757d;\n}\n\n.opponents-table {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  border: 1px solid #e9ecef;\n  overflow-x: auto;\n}\n\n.team-detail.night-mode .opponents-table {\n  background: #343a40;\n  border-color: #495057;\n}\n\n.opponents-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.opponents-table th,\n.opponents-table td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.team-detail.night-mode .opponents-table th,\n.team-detail.night-mode .opponents-table td {\n  border-bottom-color: #495057;\n  color: white;\n}\n\n.opponents-table th {\n  background: #f8f9fa;\n  font-weight: bold;\n  color: #2c3e50;\n}\n\n.team-detail.night-mode .opponents-table th {\n  background: #495057;\n  color: white;\n}\n\n.opponent-name {\n  font-weight: bold;\n  color: #007bff;\n  cursor: pointer;\n}\n\n.opponent-name:hover {\n  text-decoration: underline;\n}\n\n.opponents-table .wins {\n  color: #28a745;\n  font-weight: bold;\n}\n\n.opponents-table .losses {\n  color: #dc3545;\n  font-weight: bold;\n}\n\n.opponents-table .ties {\n  color: #ffc107;\n  font-weight: bold;\n}\n\n.win-percentage {\n  font-weight: bold;\n}\n\n.loading,\n.error-message,\n.empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  color: #6c757d;\n}\n\n.team-detail.night-mode .loading,\n.team-detail.night-mode .error-message,\n.team-detail.night-mode .empty-state {\n  color: #adb5bd;\n}\n\n.retry-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-top: 15px;\n  transition: background-color 0.2s;\n}\n\n.retry-btn:hover {\n  background: #0056b3;\n}\n\n@media (max-width: 768px) {\n  .team-detail {\n    padding: 15px;\n  }\n  \n  .team-detail-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n  \n  .team-title h1 {\n    font-size: 2rem;\n  }\n  \n  .stats-summary {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 15px;\n  }\n  \n  .charts-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .tab-btn {\n    padding: 10px 15px;\n    font-size: 14px;\n  }\n  \n  .match-item {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n  \n  .match-group,\n  .match-note {\n    grid-column: 1;\n  }\n  \n  .players-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .opponents-table {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
